import ApiService from '@/core/services/api.service'
import JwtService from '@/core/services/jwt.service'

import { LOGOUT } from './auth.module.js'
import router from '@/router'

import { eventBus } from '@/main'

// action types
export const GET_COUNTRIES = 'getCountries'

// mutation types
export const SAVE_COUNTRIES = 'saveCountries'

const SET_RESPONSE_STATE = 'setResponseState'
const TOAST_GLOBAL = 'showToast'

const state = {
  countriesList: [],

  responses: {
    countriesList: false,
  },
}

const getters = {
  countriesList(state) {
    return state.countriesList
  },
  countriesEmpty(state) {
    return state.countriesList.length == 0
  },
  totalCountries(state) {
    return state.countriesList.length
  },
  countryFlag: state => code => {
    const target = state.countriesList.filter(c => c.code == code.toLowerCase())[0]
    let vueAppHttpPublic = process.env.VUE_APP_HTTP_PUBLIC || 'https://panel-77735b946f2889f15a65455ab43ec46f.go.vpnlabel.net/public'
    let urlPublic = vueAppHttpPublic.replace(/(.*)\/+$/g, '$1')
    if (target) {
      return `${urlPublic}/${target.flag_svg}`
    }
  },
  countryName: state => code => {
    const target = state.countriesList.filter(c => c.code == code.toLowerCase())[0]
    if (target) {
      return state.countriesList.filter(c => c.code == code.toLowerCase())[0].name || ''
    }
  },
  countriesResponses: state => type => {
    return state.responses[type]
  }
}

const actions = {
  [GET_COUNTRIES](context) {
    return new Promise((resolve, reject) => {
      if (JwtService.getToken()) {
        context.commit(SET_RESPONSE_STATE, { type: 'countriesList', status: true })
        eventBus.$emit('startProgress')
        ApiService.setHeader()
        ApiService.get(process.env.VUE_APP_COUNTRIES)
          .then(({ data }) => {
            context.commit(SAVE_COUNTRIES, data)
            resolve(data)
          })
          .catch(err => {
            eventBus.$emit(TOAST_GLOBAL, {
              message: err.message,
              variant: 'danger'
            })
            reject(err)
          })
          .finally(() => {
            context.commit(SET_RESPONSE_STATE, { type: 'countriesList', status: false })
            eventBus.$emit('endProgress')
          })
      } else {
        context.dispatch(LOGOUT, null, { root: true })
          .then(() => router.push({ name: 'login' }))
          .catch(() => {})
      }
    })
  },
}

const mutations = {
  [SAVE_COUNTRIES](state, countries) {
    state.countriesList = countries
  },
  [SET_RESPONSE_STATE](state, { type, status }) {
    state.responses[type] = status
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
